/*
 * Enforce native form validation before an Ajax add-to-cart.
 *
 * In "drawer"/"message" cart modes the theme adds to cart via fetch and calls
 * preventDefault(), which skips the browser's native HTML5 validation. Products
 * with required line-item properties (e.g. the Name Tag personalisation form:
 * child's name, level, "I have reviewed" checkbox) could therefore be added
 * with blank fields. This guard re-checks validity in the capture phase and,
 * if the form is invalid, stops the theme's add-to-cart handler from firing and
 * surfaces the native validation messages instead.
 *
 * It also:
 * 1. Auto-sanitizes and uppercases child name inputs before validation (preventing
 *    accidental pattern mismatches when entering lowercase characters or during test runs).
 * 2. Overrides Safari/WebKit's generic "The string did not match the expected pattern"
 *    message with the field's descriptive title attribute (e.g. "Only Alphabet capitalized characters are accepted").
 *
 * No effect on products without required fields, and harmless in "page" mode
 * (the native submit validates anyway).
 */
(function () {
  function validateAndSanitizeForm(form, event) {
    if (!form || typeof form.checkValidity !== 'function') return true;

    var elements = form.querySelectorAll('input, select, textarea');

    // 1. Reset any prior custom validity strings so checkValidity evaluates standard rules
    for (var i = 0; i < elements.length; i++) {
      elements[i].setCustomValidity('');
    }

    // 2. Pre-sanitize uppercase text inputs (e.g. student names) before checking pattern validity
    for (var j = 0; j < elements.length; j++) {
      var el = elements[j];
      if (el.disabled || el.type === 'hidden') continue;

      // Only sanitize text inputs. Never mutate select dropdowns, checkboxes, radios, or textareas.
      if (!el.tagName || el.tagName.toUpperCase() !== 'INPUT') continue;
      var inputType = (el.type || 'text').toLowerCase();
      if (inputType !== 'text') continue;

      var pattern = el.getAttribute('pattern') || '';
      var style = el.getAttribute('style') || '';
      var oninputAttr = el.getAttribute('oninput') || '';

      if (pattern.indexOf('[A-Z') !== -1 || style.indexOf('uppercase') !== -1 || oninputAttr.indexOf('maxLengthCheck') !== -1) {
        if (typeof window.maxLengthCheck === 'function' && oninputAttr.indexOf('maxLengthCheck') !== -1) {
          window.maxLengthCheck(el);
        } else if (el.value) {
          el.value = el.value.toUpperCase();
        }
      }
    }

    // 3. Check form validity
    if (!form.checkValidity()) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation(); // block the theme's Ajax add handler
      }

      // 4. Safari/WebKit displays a cryptic "The string did not match the expected pattern" on patternMismatch.
      // Replace with the descriptive title attribute so users and testers see clear instructions.
      for (var k = 0; k < elements.length; k++) {
        var item = elements[k];
        if (item.validity && item.validity.patternMismatch) {
          var hint = item.getAttribute('title') || 'Please enter the required format.';
          item.setCustomValidity(hint);

          // Clear custom validity when the user modifies the input
          (function (targetItem) {
            function onClear() {
              targetItem.setCustomValidity('');
              targetItem.removeEventListener('input', onClear);
              targetItem.removeEventListener('change', onClear);
            }
            targetItem.addEventListener('input', onClear);
            targetItem.addEventListener('change', onClear);
          })(item);
        }
      }

      // 5. Scroll to and focus the first invalid input so mobile shoppers see the prompt immediately (prevents dead clicks)
      var firstInvalid = form.querySelector(':invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try {
          firstInvalid.focus({ preventScroll: true });
        } catch (focusErr) {
          firstInvalid.focus();
        }
      }

      form.reportValidity();
      return false;
    }

    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-action="add-to-cart"]');
      if (!button) return;

      var form = button.closest('form[action*="/cart/add"]');
      if (form) {
        validateAndSanitizeForm(form, event);
      }
    },
    true // capture phase: run before the theme's bubble-phase listener
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        validateAndSanitizeForm(form, event);
      }
    },
    true
  );
})();
